<template>
    <div class="p-5 lg:p-4 text-sm color-primary bg-white w-full font-bold mb-auto border-t border-gray-200 ">
        <Link :href="route($page.props.locale + '.opportunities')">
            {{ $__('opportunities.all') }}
        </Link>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3';

export default {
    components: {Link}
}
</script>
